import React, { FC, useEffect, useState } from "react";
import { Row, Collapse, Button } from "antd";
import { cloneDeep } from "lodash";

import PinUnpin from "@pages/member-details/pin-unpin-component";
import CustomTooltip from "@pages/tool-tip";
import { RisksProvider, UseRisksContext } from "./risks/useRisks";
import { Risks } from "./risks";

const { Panel } = Collapse;

const Heading = (props: any) => {
  const title = [`Utilization Measures`, props.dateRange ? `(${props.dateRange})` : ''].join(' ');
  return (
    <>
      <span>{title}</span>
      <CustomTooltip
        toolTipvalue={title}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  )
}

const Extra = (props: any) => {
  const { expanded, setexpanded } = UseRisksContext()

  return (
    <Row align="middle" >
      <Button
        className="ui-utilization-measures__show-action"
        type="link"
        onClick={
          (e) => {
            e.stopPropagation()
            setexpanded && setexpanded(!expanded)
          }
        }
      >
        Show {expanded ? 'Less' : 'More'}
      </Button>
      <PinUnpin
        marginRight={"16px"}
        dataCardId={props?.data?.dataCardId}
        changeHandler={props?.pinChangeHandler}
        pinCardIds={props.pinCardIds}
      />
    </Row>
  )
}

const UtilizationMeasures: FC<any> = (props) => {

  const dataCardId = "26";

  const [activeCardPanel, setActiveCardPanel] = useState<any[]>(props?.activeKey?.includes(dataCardId) ? ["1"] : []);

  useEffect(()=>{
    console.log("UtilizationMeasures.useEffect");
    setActiveCardPanel(props.activeKey?.includes(dataCardId) ? ["1"] : [])
  }, [props.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else {
      props.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
    }
  }

  return (
    <RisksProvider types={props?.data?.measureTypes || []}>
      <Collapse
        accordion
        activeKey={activeCardPanel}
        expandIconPosition="right"
        bordered={false}
        onChange={onCollapseChange}
      >
        <Panel
          className="title ui-utilization-measures"
          header={<Heading dateRange={props?.data?.dateRange || ''} />}
          key="1"
          extra={<Extra {...props} />}
          style={{marginBottom: "8px"}}
        >
          <Risks />
        </Panel>
      </Collapse>
    </RisksProvider>
  );
};

export default UtilizationMeasures;
